export default {"src":"/_next/static/media/eye.12f354e4.svg","height":14,"width":14};